import { render, staticRenderFns } from "./AwardedMenu.vue?vue&type=template&id=2b8d21e1&"
import script from "./AwardedMenu.vue?vue&type=script&lang=js&"
export * from "./AwardedMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports